"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollAcquisitionMethod = void 0;
var PayrollAcquisitionMethod;
(function (PayrollAcquisitionMethod) {
    PayrollAcquisitionMethod["GUSTO"] = "GUSTO";
    PayrollAcquisitionMethod["FINCH"] = "FINCH";
    PayrollAcquisitionMethod["FILE"] = "FILE";
    PayrollAcquisitionMethod["MANUAL"] = "MANUAL";
})(PayrollAcquisitionMethod || (exports.PayrollAcquisitionMethod = PayrollAcquisitionMethod = {}));
